import { Footer } from "./sections/footer/footer";
import { Header } from "./sections/header/header";
import styles from "./home.module.css";
import { HowItWorks } from "./sections/howItWorks";

export const HomePage = () => (
  <div className={styles.homePage}>
    <Header />
    <div className={styles.mainContent}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Schrijf van je af
            <br />
            <span className={styles.subtitle}>dat lucht op</span>
          </h1>
          <p className={styles.description}>
            Leuk dat je een kijkje neemt bij Opluchtpost. We zijn er voor jou. Misschien heb je iemand verloren die je mist,
            misschien ervaar je verlies op een andere plek van je leven. Het kan fijn zijn om je gedachten op papier te
            zetten. Opluchtpost is er als bestemming van je gedachten en gevoelens. We lezen wat je te vertellen hebt en als
            je een adres achter laat, sturen we je een gedicht of andere bemoediging terug. Opluchtpost is de brievenbus naar
            wat anders onbestemd zou zijn.
          </p>
          <div className={styles.iconContainer}>
            <div
              className={styles.icon}
              aria-hidden="true"
              onClick={() => {
                const isMobile = window.innerWidth <= 768;
                const scrollTarget = isMobile
                  ? window.scrollY + window.innerHeight * 0.9
                  : window.scrollY + window.innerHeight * 1.1;
                window.scrollTo({ top: scrollTarget, behavior: "smooth" });
              }}
            >
              <svg
                width="80"
                height="45"
                viewBox="0 0 64 64"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
              >
                <circle cx="32" cy="32" r="30" fill="#5f79c4" />
                <line x1="32" y1="18" x2="32" y2="42" stroke="#ffffff" strokeWidth="4" strokeLinecap="round" />
                <path d="M24 42 L32 50 L40 42 Z" fill="#ffffff" />
              </svg>
            </div>
          </div>
        </div>
        <div className={styles.logo}>
          <img src="/logo/Opluchtpost - Logo RGB - Midres.png" alt="OpluchtPost Logo" className={styles.logoImage} />
        </div>
      </div>
      <HowItWorks />
    </div>

    <Footer />
  </div>
);
